import type { ScText } from '@legacy/common-ui-models';

export function fieldToValue(field?: ScText, defaultValue = ''): string {
  return field?.value || defaultValue;
}
